import { postRequestWithRetry } from './asyncRequest';
import { logger } from './logger';
import { AjaxLandingMetricsPublisher } from './metrics';
import { BANNER_TYPE } from 'src/app/slice';

const landingAppEndpoint = '/ccx/ajax/setLanding';
const header: Record<string, string> = {
  'Content-type': 'application/json; charset=UTF-8',
};

interface SetToastBannerArgs {
  showToastBanner: boolean;
  toastBannerType: BANNER_TYPE;
}

interface SetLandingAppActionProps {
  appName: string;
  updateLandingAppName: (arg: string) => void;
  setToastBanner: (args: SetToastBannerArgs) => void;
}

interface UnsetLandingAppActionProps {
  updateLandingAppName: (arg: string) => void;
  setToastBanner: (args: SetToastBannerArgs) => void;
}

export const setLandingAppAction = async ({
  appName,
  updateLandingAppName,
  setToastBanner,
}: SetLandingAppActionProps): Promise<void> => {
  if (appName.length === 0) {
    return;
  }
  AjaxLandingMetricsPublisher.publishCounterMonitor('setRequest', 1);
  try {
    await postRequestWithRetry({
      params: { landingAppName: appName },
      url: landingAppEndpoint,
      timeout: null,
      header,
    });
    updateLandingAppName(appName);
    setToastBanner({
      showToastBanner: true,
      toastBannerType: BANNER_TYPE.SUCCESS,
    });
  } catch (error: any) {
    AjaxLandingMetricsPublisher.publishCounterMonitor('setError', 1);
    await logger.error(
      `Fail when setLandingAppAction to endpoint ${landingAppEndpoint} for appName ${appName} with error ${error}`,
    );
    setToastBanner({
      showToastBanner: true,
      toastBannerType: BANNER_TYPE.ERROR,
    });
  }
};

export const unsetLandingAppAction = async ({
  updateLandingAppName,
  setToastBanner,
}: UnsetLandingAppActionProps): Promise<void> => {
  AjaxLandingMetricsPublisher.publishCounterMonitor('unsetRequest', 1);
  try {
    await postRequestWithRetry({
      url: landingAppEndpoint,
      timeout: null,
      header,
    });
    updateLandingAppName('');
    setToastBanner({
      showToastBanner: true,
      toastBannerType: BANNER_TYPE.SUCCESS,
    });
  } catch (error: any) {
    await logger.error(
      `Fail when unsetLandingAppAction to endpoint ${landingAppEndpoint} with error ${error}`,
    );
    AjaxLandingMetricsPublisher.publishCounterMonitor('unsetError', 1);
    setToastBanner({
      showToastBanner: true,
      toastBannerType: BANNER_TYPE.ERROR,
    });
  }
};
